import { render, staticRenderFns } from "./ModelShow.vue?vue&type=template&id=6c9bdb8e&"
import script from "./ModelShow.vue?vue&type=script&lang=js&"
export * from "./ModelShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports